import { useCallback, useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import ModalContext from '~/contexts/ModalContext';
import UserContext, { useUserData } from '~/contexts/UserContext';
import useOpenAccountModal from '~/hooks/useOpenAccountModal';
import { SearchDispatcherEvent } from '~/native/dispatchers/constants';
import sendMessageToNative from '~/native/dispatchers/sendMessageToNative';

function useLoginAndSaveSearch() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setCreateSavedSearchOpen } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const openAccountModal = useOpenAccountModal();
  const { isLoggedIn } = useUserData();

  const onSuccess = useCallback(() => {
    triggerFetchUserProfile();
    setCreateSavedSearchOpen(true, appliedFilters);
  }, [appliedFilters, setCreateSavedSearchOpen, triggerFetchUserProfile]);

  return useCallback(() => {
    if (isLoggedIn) {
      setCreateSavedSearchOpen(true, appliedFilters);

      return;
    }

    openAccountModal({
      callerIdentifier: 'SearchAlert',
      modalTitle: 'SAVE YOUR SEARCH',
      onSuccess
    });

    sendMessageToNative(SearchDispatcherEvent.SaveSearch, {});
  }, [
    appliedFilters,
    isLoggedIn,
    onSuccess,
    openAccountModal,
    setCreateSavedSearchOpen
  ]);
}

export default useLoginAndSaveSearch;
